import globModules from './glob-modules';

import { render } from '@verndale/core';
import InputField from './components/input-field';
import Modal from './components/modal';
import CountrySelector from './components/country-selector';
import { spinner } from './modules/rmpc-dashboard';

function handleAnchorClick(e) {
  const anchor = e.target.closest('a');
  if (anchor) {
    if (
      anchor.hasAttribute('href') &&
      !anchor.getAttribute('href')?.startsWith('#') &&
      anchor.target !== '_blank' &&
      !anchor.getAttribute('data-network') &&
      anchor.pathname !== window.location.pathname &&
      !anchor.getAttribute('href')?.includes('mailto:') &&
      !anchor.getAttribute('href')?.includes('tel:') &&
      !anchor.hasAttribute('data-trigger-modal') &&
      !anchor.hasAttribute('download') &&
      !anchor.getAttribute('href').endsWith('.pptx') &&
      !anchor.getAttribute('href').endsWith('.ppt') &&
      !anchor.closest('.rtf')
    ) {
      setTimeout(
        () => document.documentElement.insertAdjacentHTML('beforeend', spinner),
        1000
      );
    }
  }
}

function handleBack() {
  document.querySelector('html > .spinner')?.remove();

  setTimeout(() => {
    document.querySelector('html > .spinner')?.remove();
  }, 2000);
}

export function global() {
  const $modals = document._$$('.modal');
  const $inputFields = document._$$('.form-input__field');
  const $countrySelectors = document._$$('[data-country-selector-id]');
  document.addEventListener('click', handleAnchorClick);
  window.addEventListener('pageshow', handleBack);

  instantiateModule($modals, Modal);
  instantiateModule($inputFields, InputField);
  instantiateModule($countrySelectors, CountrySelector);
  removeCaptchaSubmit();
}

const removeCaptchaSubmit = () => {
  const $captchaSubmitButtons = document._$$('.FormCaptcha__Refresh');

  $captchaSubmitButtons.forEach(button => {
    button.setAttribute('type', 'button');
  });
};

const instantiateModule = (elements, Module) =>
  render(elements, el => new Module(el));

const modules = [
  {
    name: 'video-highlight',
    loader: () => import('./modules/video-highlight')
  },
  {
    name: 'video-modal',
    loader: () => import('./modules/video-modal')
  },
  {
    name: 'content-cards-slider',
    loader: () => import('./modules/content-cards-slider')
  },
  {
    name: 'inline-video',
    loader: () => import('./modules/inline-video')
  },
  {
    name: 'promotional-cards',
    loader: () => import('./modules/promotional-cards')
  },
  {
    name: 'share',
    loader: () => import('./modules/share')
  },
  {
    name: 'leadership-landing-team-selector',
    loader: () => import('./modules/leadership-landing-team-selector')
  },
  {
    name: 'leadership-landing-advisory-committees',
    loader: () => import('./modules/leadership-landing-advisory-committees')
  },
  {
    name: 'contact-us-request-information',
    loader: () => import('./modules/contact-us-request-information')
  },
  {
    name: 'episerver-form',
    loader: () => import('./components/episerver-form')
  },
  {
    name: 'register-trigger',
    loader: () => import('./modules/register-trigger')
  },
  {
    name: 'rtf',
    loader: () => import('./modules/rtf')
  },
  {
    name: 'campaign-landing-form',
    loader: () => import('./modules/campaign-landing-form')
  },
  {
    name: 'account-navigation',
    loader: () => import('./modules/account-navigation')
  },
  {
    name: 'change-institution',
    loader: () => import('./modules/change-institution')
  },
  {
    name: 'alert',
    loader: () => import('./components/alert')
  },
  {
    name: 'document-list',
    loader: () => import('./modules/document-list')
  },
  {
    name: 'reports-list',
    loader: () => import('./modules/reports-list')
  },
  {
    name: 'report-detail-overview',
    loader: () => import('./modules/report-detail-overview')
  },
  {
    name: 'incident-download-modal',
    loader: () => import('./modules/incident-download-modal')
  },
  {
    name: 'favorite-button',
    loader: () => import('./modules/favorite-button')
  },
  {
    name: 'download-api-file',
    loader: () => import('./components/download-api-file')
  },
  {
    name: 'document-library-queue',
    loader: () => import('./components/document-library-queue')
  },
  {
    name: 'speaker-modal',
    loader: () => import('./modules/speaker-modal')
  },
  {
    name: 'jumplinks',
    loader: () => import('./modules/jumplinks')
  }
];

export default [...globModules, ...modules];
